import { defineAsyncComponent, markRaw } from 'vue'

// İlk gezinmede route kaydı henüz yüklenmemiş bileşenin yükleyicisini (`() => import(...)`) taşır; Vue 3'te
// `<component :is>`'e verilen çıplak fonksiyon fonksiyon bileşen sayılır, bu yüzden async bileşene sarılır.
const asComponent = component => (typeof component === 'function' ? defineAsyncComponent(component) : component)


const state = {
  currentModalId: '',
  currentModalTitle: '',
  dynamicComponent: null,
  componentProps: null
}

const mutations = {
  saveSetCurrentModalId(state, currentModalId) {
    state.currentModalId = currentModalId
  },
  saveSetCurrentModalTitle(state, currentModalTitle) {
    state.currentModalTitle = currentModalTitle
  },
  saveSetDynamicComponent(state, dynamicComponent) {
    // Bileşen tanımı (ya da ilk gezinmedeki lazy yükleyici) reaktif state'e proxy olarak girmemeli.
    state.dynamicComponent = dynamicComponent ? markRaw(asComponent(dynamicComponent)) : dynamicComponent
  },
  saveSetComponentProps(state, componentProps) {
    state.componentProps = componentProps
  }
}

const actions = {
  setCurrentModalId({ commit }, currentModalId) {
    commit('saveSetCurrentModalId', currentModalId)
  },
  setCurrentModalTitle({ commit }, currentModalTitle) {
    commit('saveSetCurrentModalTitle', currentModalTitle)
  },
  setDynamicComponent({ commit }, dynamicComponent) {
    commit('saveSetDynamicComponent', dynamicComponent)
  },
  setComponentProps({ commit }, componentProps) {
    commit('saveSetComponentProps', componentProps)
  }
}

const getters = {
  currentModalId: state => {
    return state.currentModalId
  },
  currentModalTitle: state => {
    return state.currentModalTitle
  },
  dynamicComponent: state => {
    return state.dynamicComponent
  },
  componentProps: state => {
    return state.componentProps
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
